import { Component } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter } from '@angular/material/core';
import { DateFormat } from '@vendasta/galaxy/utility/date-utils';
import { PopoverPositions } from '@vendasta/galaxy/popover';

@Component({
  template: `
    <div class="value" [glxyPopover]="popover" (mouseenter)="showTooltip()" (mouseleave)="hideTooltip()">
      {{ value | date }}
    </div>
    <glxy-popover
      #popover
      [positions]="positions"
      [isOpen]="showPopover"
      [hasArrow]="true"
      [highContrast]="false"
      [padding]="'small'"
    >
      <span>{{ ('GALAXY.TABLE.DATE_CELL.LOCAL_TIME' | translate) + ': ' + (value | date: longFormat) }}</span>
      <br />
      <span>{{ ('GALAXY.TABLE.DATE_CELL.UTC' | translate) + ': ' + (value | date: longFormat : '+0000') }}</span>
    </glxy-popover>
  `,
  providers: [
    // for browsers with a negative GMT, the default datepicker would show the previous day
    { provide: DateAdapter, useClass: MomentDateAdapter },
  ],
  standalone: false,
})
export class DateRendererComponent {
  positions = [PopoverPositions.Top, PopoverPositions.Bottom];
  showPopover = false;
  longFormat = DateFormat.long;
  value: Date = new Date(0);

  showTooltip(): void {
    this.showPopover = true;
  }

  hideTooltip(): void {
    this.showPopover = false;
  }
}
